import { Card, CardBody, CardHeader, Field, TextInput } from "@odingard/design-system";
import { useAuth } from "../../lib/auth";

export function Settings() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <>
      <div className="page-head">
        <div>
          <h1>Settings</h1>
          <p>Your profile and preferences.</p>
        </div>
      </div>
      <div className="two-col">
        <Card>
          <CardHeader title="Profile" />
          <CardBody>
            <Field label="Display name">{(id) => <TextInput id={id} defaultValue={user.displayName} readOnly />}</Field>
            <Field label="Email">{(id) => <TextInput id={id} defaultValue={user.email} readOnly />}</Field>
            <p style={{ color: "var(--ods-color-muted)", fontSize: "var(--ods-text-sm)" }}>
              Profile editing is managed by your identity provider in production.
            </p>
          </CardBody>
        </Card>
        <Card>
          <CardHeader title="Security" />
          <CardBody>
            <dl className="kv">
              <dt>Sessions</dt>
              <dd>Bearer tokens stored as hashes; expire after 12 hours.</dd>
              <dt>MFA</dt>
              <dd>Managed by your identity provider.</dd>
            </dl>
          </CardBody>
        </Card>
      </div>
    </>
  );
}
